//Ensemble des cartes du chiffroscope
const data = {
  "cartes-nombres": {
    N1: {
      N1C1: 0,
      N1C2: 1,
      N1C3: 2,
      N1C4: 3,
      N1C5: 4,
      N1C6: 1,
      N1C7: 2,
      N1C8: 2,
      N1C9: 3,
    },
    N2: {
      N2C1: 0,
      N2C2: 1,
      N2C3: 3,
      N2C4: 4,
      N2C5: 5,
      N2C6: 6,
      N2C7: 7,
      N2C8: 7,
      N2C9: 8,
    },
    N3: {
      N3C1: 4,
      N3C2: 6,
      N3C3: 9,
      N3C4: 15,
      N3C5: 20,
      N3C6: 2,
      N3C7: 2,
      N3C8: 4,
      N3C9: 0,
    },
    N4: {
      N4C1: 2,
      N4C2: 3,
      N4C3: 7,
      N4C4: 8,
      N4C5: 9,
      N4C6: 14,
      N4C7: 16,
      N4C8: 23,
      N4C9: 30,
    },
    N5: {
      N5C1: 8,
      N5C2: 11,
      N5C3: 19,
      N5C4: 23,
      N5C5: 28,
      N5C6: 34,
      N5C7: 45,
      N5C8: 50,
      N5C9: 67,
    },
  },
  "cartes-unites": {
    U1: {
      U1C1: "Unités",
      U1C2: "Unités",
      U1C3: "Dizaines",
      U1C4: "Dizaines",
    },
    U2: {
      U2C1: "Unités",
      U2C2: "Unités",
      U2C3: "Unités",
      U2C4: "Dizaines",
      U2C5: "Dizaines",
      U2C6: "Dizaines",
      U2C7: "Centaines",
      U2C8: "Centaines",
      U2C9: "Centaines",
    },

    U3: {
      U3C1: "Unités",
      U3C2: "Unités",
      U3C3: "Unités de mille",
      U3C4: "Dizaines",
      U3C5: "Dizaines",
      U3C6: "Unités de mille",
      U3C7: "Centaines",
      U3C8: "Centaines",
      U3C9: "Centaines",
    },
    U4: {
      U4C1: "Unités de mille",
      U4C2: "Unités de mille",
      U4C3: "Unités de mille",
      U4C4: "Dizaines",
      U4C5: "Dizaines",
      U4C6: "Dizaines",
    },
    U5: {
      U5C1: "Unités de mille",
      U5C2: "Unités de mille",
      U5C3: "Unités de mille",
      U5C4: "Dizaines",
      U5C5: "Dizaines",
      U5C6: "Dizaines",
      U5C8: "Dizaines de mille",
      U5C7: "Unités de millions",
      U5C9: "Unités de millions",
    },
    U6: {
      U6C1: "Unités de millions",
      U6C2: "Unités de millions",
      U6C3: "Unités de millions",
      U6C4: "Dizaines de mille",
      U6C5: "Dizaines de mille",
      U6C6: "Dizaines de mille",
      U6C7: "Centaines de mille",
      U6C8: "Centaines de mille",
      U6C9: "Centaines de mille",
    },
    U7: {
      U7C1: "Centaines",
      U7C2: "Centaines",
      U7C3: "Dizaines de mille",
      U7C4: "Centaines de mille",
      U7C5: "Centaines de mille",
      U7C6: "Unités de millions",
      U7C7: "Unités de millions",
      U7C8: "Centaines de millions",
      U7C9: "Centaines de millions",
    },
    U8: {
      U8C1: "Unités",
      U8C2: "Dizaines",
      U8C3: "Centaines",
      U8C4: "Unités de mille",
      U8C5: "Dizaines de mille",
      U8C6: "Centaines de mille",
      U8C7: "Unités de millions",
      U8C8: "Dizaines de millions",
      U8C9: "Centaines de millions",
    },
    U9: {
      U9C1: "Dizaines",
      U9C2: "Dizaines",
      U9C3: "Unités",
      U9C4: "Unités",
      U9C5: "Dixièmes",
      U9C6: "Dixièmes",
      U9C7: "Dixièmes",
      U9C8: "Centièmes",
      U9C9: "Centièmes",
    },
    U10: {
      U10C1: "Dizaines",
      U10C2: "Dizaines",
      U10C3: "Dizaines",
      U10C4: "Dixièmes",
      U10C5: "Dixièmes",
      U10C6: "Dixièmes",
      U10C7: "Millièmes",
      U10C8: "Millièmes",
      U10C9: "Millièmes",
    },
  },
};

export default data;
